
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Being the building blocks of the design system, components represent simple groupings of user interface elements (e.g. a label, an input field and a button to form a search field) through which we inform users of the expected interaction steps in order to help them achieve their goal.`}</p>
    <p>{`Every component is coded to serve a function and designed to solve a specific user interface problem. They can be used stand-alone or in conjunction with others as parts of a greater, harmonious whole.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;